import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const AIDevelopment = () => {
  return <PageTemplate title="AI Development" subtitle="Custom AI Solutions" breadcrumb="AI & Data > AI Development"><div className="content-section"><p>Machine learning, computer vision, NLP, and custom AI development services.</p></div></PageTemplate>;
};
export default AIDevelopment; 